import React from 'react';
import Helmet from 'react-helmet';

//
// === Initialize global Analytics ===
//

export const Initialize = () => {
  const pageView = async location => {
    global.gtag &&
      global.gtag('event', 'page_view', { page_location: location.href });
  };

  const productView = async (product = {}) => {
    global.gtag && global.gtag('event', 'view_item', { items: [item] });

    // klaviyo view product
    var _learnq = _learnq || [];

    var item = {
      Name: product.title,
      ProductID: product.id,
      Categories: product.category,
      ImageURL: product.imageUrl,
      URL: product.productUrl,
      Price: product.price,
      CompareAtPrice: product.compareAtPrice,
    };

    _learnq.push(['track', 'Viewed Product', item]);
    _learnq.push([
      'trackViewedItem',
      {
        Title: item.Name,
        ItemId: item.ProductID,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice,
        },
      },
    ]);
  };

  const addToCart = async (product = {}) => {
    global.gtag && global.gtag('event', 'add_to_cart', { items: [item] });

    // klaviyo
    var _learnq = _learnq || [];

    var item = {
      Name: product.title,
      ProductID: product.id,
      Categories: product.type,
      ImageURL: product.imageUrl,
      URL: product.productUrl,
      Price: product.defaultPrice,
      CompareAtPrice: product.compareAtPrice,
    };

    _learnq.push(['track', 'Added to Cart', item]);
  };

  const removeFromCart = (item = {}) => {
    global.gtag && global.gtag('event', 'remove_from_cart', { items: [item] });
  };

  const initiateCheckout = async () => {
    global.gtag && global.gtag('event', 'Initiate Checkout');
  };

  // Attach all analytics functions to window
  window.analytics = {
    pageView,
    productView,
    addToCart,
    removeFromCart,
    initiateCheckout,
  };

  return window.analytics;
};

//
// === Group all script tags here` ===
//

export default ({ facebookPixelId, klaviyoId }) => {
  React.useEffect(() => {
    Initialize();
  }, []); // Run once on mount

  return (
    <Helmet>
      {/* Facebook */}
      {/* <!-- Google tag (gtag.js) -->  */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-7LHVSNE9L9"
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', 'G-7LHVSNE9L9');
        `}
      </script>
      {facebookPixelId && (
        <script>{`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${facebookPixelId}');
        `}</script>
      )}
      {facebookPixelId && (
        <noscript>{`
          <img
            height="1"
            width="1"
            style="display:none"
            src="https://www.facebook.com/tr?id=${facebookPixelId}&ev=PageView&noscript=1"
          />
        `}</noscript>
      )}
      {klaviyoId && (
        <script
          type="application/javascript"
          async
          src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoId}`}
        ></script>
      )}
    </Helmet>
  );
};
